module.exports = __webpack_public_path__ + "img/aanchal_img_new2.6d3cb063.png";